import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Chat from "@/pages/Chat";
import SharedChat from "@/pages/SharedChat";
import EmbedChat from "@/pages/EmbedChat";
import EmbedCheck from "@/pages/EmbedCheck";
import Check from "@/pages/Check";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/chat/:id" element={<Chat />} />
        <Route path="/s/:slug" element={<SharedChat />} />
        <Route path="/embed" element={<EmbedChat />} />
        <Route path="/embed-check" element={<EmbedCheck />} />
        <Route path="/check" element={<Check />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
